/* Sop. Essential · Configurador Kit AM6 · parte 4 de 4: miniaturas, logos, carrito (requiere sop-kit.js, -2 y -3) */
(function () {
  'use strict';
  var S = window.SopKit, Kit = S.Kit, PROPS = S.PROPS, SOURCE = S.SOURCE, STEPS = S.STEPS, esc = S.esc, fmt = S.fmt, storeClear = S.storeClear, b64encode = S.b64encode;
  var SHEET_TITLES = { top: 'Logo de arriba', center: 'Logo del centro', bottom: 'Logo de abajo', pinon: 'Logo o dibujo del piñón' };

  /* ---------------- resumen y envío ---------------- */

  Kit.prototype.selectedExtras = function () {
    return this.$$('[data-up]').map(function (li) { return li._skExtra && li._skExtra(); }).filter(Boolean);
  };

  // Envío gratis: lo que falta ahora según el carrito real (leído en directo) y lo que faltaría con el kit y los extras
  Kit.prototype.refreshCart = function () {
    var self = this;
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { self.data.cartTotal = c.total_price || 0; self.render(); })
      .catch(function () {});
  };
  Kit.prototype.renderShipping = function (add) {
    var box = this.$('[data-sk-ship]');
    if (!box || !this.data.freeShipping) return;
    var free = this.data.freeShipping, cart = this.data.cartTotal || 0, now = free - cart, after = now - add;
    var what = this.selectedExtras().length ? 'tu kit y los extras' : 'tu kit';
    box.querySelector('[data-ship-bar]').style.width = Math.min(100, Math.round((cart + add) * 100 / free)) + '%';
    box.classList.toggle('is-ok', after <= 0);
    box.querySelector('[data-ship-text]').innerHTML = now <= 0 ? '<b>Envío gratis</b>: ya lo tienes con lo que llevas en el carrito.'
      : cart <= 0 ? (after <= 0 ? 'Con ' + what + ' tienes el <b>envío gratis</b>.' : 'Envío gratis desde ' + fmt(free) + '. Con ' + what + ' te faltarían <b>' + fmt(after) + '</b>.')
      : 'En tu carrito llevas ' + fmt(cart) + ': te faltan <b>' + fmt(now) + '</b> para el envío gratis.' +
        (after <= 0 ? ' Con ' + what + ', <b>ya lo tienes</b>.' : ' Con ' + what + ' te quedarían <b>' + fmt(after) + '</b>.');
  };

  Kit.prototype.summaryRows = function () {
    var s = this.state, pe = this.pinonEntry(), ig = this.clean(s.igTapa), c = this.igContact();
    var rows = [[1, 'Tapa', s.design], [2, 'Piñón', s.pmodel], [2, 'En el piñón', pe ? pe.value + ' (' + pe.kind.toLowerCase() + ')' : '']];
    rows.push([3, 'Color principal', this.colorValue('base')], [3, 'Color detalles', this.colorValue('det')], [3, 'Color letras', this.colorValue('let')]);
    this.$$('[data-step="3"] .sk-group').forEach(function (g) {
      var inp = g.querySelector('[data-opt]');
      if (inp) rows.push([3, g.querySelector('legend').textContent.trim(), s.opts[+inp.dataset.opt]]);
    });
    rows.push([4, 'Logo arriba', this.slotValue('top') || 'Sin logo'], [4, 'Logo centro', this.slotValue('center')], [4, 'Logo abajo', this.slotValue('bottom') || 'Sin logo']);
    rows.push([5, '@ en la tapa', s.igOn === 'SÍ' ? (ig ? '@' + ig : '') : s.igOn === 'NO' ? 'No' : '']);
    rows.push([5, 'Diseño a', this.contactOut()]);
    return rows;
  };

  Kit.prototype.renderSummary = function () {
    var dl = this.$('[data-sk-summary]'), self = this;
    if (!dl || this.step !== STEPS) return;
    dl.innerHTML = this.summaryRows().map(function (r) {
      return '<div class="sk-summary__row' + (r[2] ? '' : ' is-missing') + '"><dt>' + esc(r[1]) + '</dt><dd>' + (r[2] ? esc(r[2]) : 'Falta') +
        '</dd><dd><button type="button" class="sk-link" data-goto-sum="' + r[0] + '">Cambiar<span class="sk-vh"> ' + esc(r[1]) + '</span></button></dd></div>';
    }).join('');
    Array.prototype.forEach.call(dl.querySelectorAll('[data-goto-sum]'), function (b) {
      b.addEventListener('click', function () { self.showStep(+b.dataset.gotoSum, true); });
    });
  };

  /* ---------------- miniaturas ---------------- */

  // Las miniaturas de tapa se dibujan con el mismo SVG y se recolorean solas (variables CSS)
  Kit.prototype.loadThumbs = function () {
    var self = this;
    function go() {
      self.$$('[data-thumb-tpl]').forEach(function (el) {
        var t = S.TPL_FILES[el.dataset.thumbTpl];
        if (el.querySelector('img') || !t) return;
        el.classList.add('is-loading');
        S.loadScript(self.data.assetBase + t[0]).then(function () {
          var p = window[t[1]];
          if (p) el.innerHTML = self.coverSvg(p, false);
          el.classList.remove('is-loading');
        }, function () {});
      });
      self.renderPinonThumbs();
    }
    if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 300);
  };

  Kit.prototype.renderPinonThumbs = function () {
    var self = this, pe = this.pinonEntry() || { show: '23' };
    this.$$('[data-thumb-pinon]').forEach(function (el) {
      if (el.querySelector('img')) return;
      el.innerHTML = self.pinonSvg(+el.dataset.thumbPinon, pe, function () { self.renderPinonThumbs(); });
    });
  };

  var baseRender = Kit.prototype.render;
  Kit.prototype.render = function () {
    baseRender.call(this);
    if (this.step === 2) this.renderPinonThumbs();
  };

  /* ---------------- hoja de logos ---------------- */

  Kit.prototype.openLogos = function (slot) {
    var self = this, sheet = this.$('[data-sk-logos]');
    this.pickSlot = slot;
    sheet.querySelector('[data-sheet-title]').textContent = SHEET_TITLES[slot] || 'Elige un logo';
    var cur = slot === 'pinon' ? this.state.plogo : this.state[slot];
    function draw() {
      sheet.querySelector('[data-sheet-grid]').innerHTML = self.logos.map(function (name) {
        var on = cur && cur.type === 'logo' && cur.value === name;
        return '<button type="button" class="sk-logo' + (on ? ' is-on' : '') + '" data-logo="' + esc(name) + '" role="listitem" aria-pressed="' + on + '">' +
          '<span class="sk-logo__img">' + self.logoThumb(name) + '</span><span class="sk-logo__name">' + esc(name) + '</span></button>';
      }).join('');
    }
    draw();
    this.ensureLogoData().then(draw);
    sheet.querySelector('[data-sheet-search]').value = '';
    sheet.querySelector('[data-req-input]').value = cur && cur.type === 'req' ? cur.value : '';
    var req = sheet.querySelector('[data-req]');
    if (req) req.open = !!(cur && cur.type === 'req');
    if (typeof sheet.showModal === 'function') sheet.showModal(); else sheet.setAttribute('open', '');
  };

  /* ---------------- estado guardado → formulario ---------------- */

  Kit.prototype.syncInputs = function () {
    var s = this.state, self = this;
    function check(name, val) {
      self.$$('input[name="' + name + '"]').forEach(function (i) { i.checked = i.value === val; });
    }
    function val(sel, v) { var el = self.$(sel); if (el) el.value = v || ''; }
    check('sk-design', s.design);
    check('sk-pmodel', s.pmodel);
    check('sk-ptype', s.ptype);
    val('[data-ptext="num"]', s.pnum);
    val('[data-ptext="text"]', s.ptext);
    ['base', 'det', 'let'].forEach(function (k) {
      var c = s[k];
      if (!c) return;
      var match = !c.custom && self.$$('input[name="sk-' + k + '"]').some(function (i) { return i.value === c.name; });
      if (match) {
        check('sk-' + k, c.name);
      } else {
        if (!c.custom) { c.custom = true; c.h = 210; c.s = 80; c.l = 45; }
        if (!c.hex) c.hex = S.hslHex(c.h, c.s, c.l);
        check('sk-' + k, '__other');
        val('[data-picker="' + k + '"] [data-pk-ref]', c.ref);
      }
    });
    s.opts.forEach(function (v, i) { check('sk-opt-' + i, v); });
    ['top', 'center', 'bottom'].forEach(function (k) {
      if (s[k] && s[k].type === 'text') val('[data-text="' + k + '"]', s[k].value);
    });
    check('sk-igon', s.igOn);
    val('[data-ig-tapa]', s.igTapa);
    val('[data-ig]', s.ig);
    this.$('[data-ig-same]').checked = s.igSame;
    val('[data-notes]', s.notes);
  };

  /* ---------------- compartir ---------------- */

  Kit.prototype.share = function () {
    var url = location.origin + location.pathname + '?kit=' + b64encode(this.state);
    var self = this;
    if (navigator.share) {
      navigator.share({ title: 'Mi kit AM6', text: 'Mira el kit que me he diseñado para la moto', url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { self.toast('Enlace copiado. Pásaselo a quien quieras.'); });
    } else {
      window.prompt('Copia este enlace:', url);
    }
  };

  Kit.prototype.toast = function (msg) {
    var t = this.$('[data-sk-toast]');
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(this._toast);
    this._toast = setTimeout(function () { t.hidden = true; }, 3200);
  };

  /* ---------------- carrito ---------------- */

  Kit.prototype.properties = function () {
    var s = this.state, out = [], pe = this.pinonEntry();
    function add(k, v) { if (v) out.push([PROPS[k], v]); }
    add('design', s.design);
    add('pmodel', s.pmodel);
    add('top', this.slotValue('top'));
    add('center', this.slotValue('center'));
    add('bottom', this.slotValue('bottom'));
    add('base', this.colorValue('base'));
    add('det', this.colorValue('det'));
    add('let', this.colorValue('let'));
    add('pinon', pe && pe.value);
    add('ptype', pe && pe.kind);
    add('igOn', s.igOn);
    if (s.igOn === 'SÍ') add('igTapa', '@' + this.clean(s.igTapa));
    add('ig', this.contactOut());
    add('notes', (s.notes || '').trim());
    add('source', SOURCE);
    return out;
  };

  // Imagen del diseño para el pedido (como el configurador de la tapa): la vista previa con sus colores, en PNG
  var SEAM = '<style>path[style*="--c-base"],path[fill="var(--c-base)"]{stroke:var(--c-base)}path[style*="--c-details"],path[fill="var(--c-details)"]{stroke:var(--c-details)}' +
    'path[style*="--c-base"],path[fill="var(--c-base)"],path[style*="--c-details"],path[fill="var(--c-details)"]{stroke-width:1.2px;stroke-linejoin:round;vector-effect:non-scaling-stroke}</style>';
  Kit.prototype.designPng = function () {
    var svg = this.$('[data-sk-tapa] svg.sk-kit');
    if (!svg) return Promise.resolve(null);
    var vb = svg.getAttribute('viewBox').split(/[\s,]+/).map(Number), W = 1600, H = Math.round(W * vb[3] / vb[2]);
    var vars = '--c-base:' + this.hex('base') + ';--c-details:' + this.hex('det') + ';--c-letters:' + this.hex('let');
    var xml = svg.outerHTML.replace(/^<svg/, '<svg' + (/^<svg[^>]*xmlns=/.test(svg.outerHTML) ? '' : ' xmlns="http://www.w3.org/2000/svg"') +
      ' width="' + W + '" height="' + H + '" style="' + vars + '"').replace(/>/, '>' + SEAM);
    return new Promise(function (resolve) {
      var img = new Image(), done = function (b) { if (resolve) { resolve(b || null); resolve = null; } };
      setTimeout(done, 4000);
      img.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          c.getContext('2d').drawImage(img, 0, 0, W, H);
          c.toBlob(done, 'image/png');
        } catch (e) { done(); }
      };
      img.onerror = function () { done(); };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(xml);
    });
  };

  Kit.prototype.addToCart = function () {
    var self = this, btn = this.$('[data-sk-next]');
    if (btn.classList.contains('is-busy')) return;
    var v = this.currentVariant();
    var addUrl = (this.data.cartAddUrl || '/cart/add') + '.js';
    var drawer = document.querySelector('cart-drawer');
    var wantSections = drawer && typeof drawer.renderContents === 'function';
    var extras = this.selectedExtras();

    var fd = new FormData();
    fd.append('id', v.id);
    fd.append('quantity', '1');
    this.properties().forEach(function (p) { fd.append('properties[' + p[0] + ']', p[1]); });
    if (this.photo) fd.append('properties[' + PROPS.photo + ']', this.photo, this.photo.name);
    if (wantSections && !extras.length) {
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', location.pathname);
    }
    btn.classList.add('is-busy');
    btn.textContent = 'Añadiendo…';

    function post(body, json) {
      return fetch(addUrl, {
        method: 'POST',
        headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: json ? JSON.stringify(body) : body
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) throw new Error(j.description || j.message || 'No se pudo añadir al carrito.');
          return j;
        });
      });
    }

    this.designPng().then(function (png) {
      if (png) fd.append('properties[Diseño]', png, 'kit-am6-' + Date.now() + '.png');
      return post(fd, false);
    }).then(function (res) {
      if (!extras.length) return res;
      var body = {
        items: extras.map(function (e) {
          var item = { id: e.id, quantity: 1 };
          if (e.note) { item.properties = {}; item.properties[PROPS.extraNote] = e.note; }
          return item;
        })
      };
      if (wantSections) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      return post(body, true);
    }).then(function (res) {
      storeClear();
      self.refreshCart();
      if (wantSections && res.sections) {
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        window.location.href = self.data.cartUrl || '/cart';
      }
    }).catch(function (err) {
      self.toast(err.message || 'No se pudo añadir al carrito. Inténtalo otra vez.');
    }).then(function () {
      btn.classList.remove('is-busy');
      self.render();
    });
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk]'), function (el) {
      if (!el._sk) { el._sk = new Kit(el); el._sk.refreshCart(); }
    });
  }
  function refreshAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk]'), function (el) { if (el._sk) el._sk.refreshCart(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', refreshAll);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshAll(); });
  document.addEventListener('shopify:section:load', init);
})();